import { useMemo } from "react";
import { useAccountAccesses } from "@/hooks/useAccountAccesses";
import { DocID } from "@/types";

/**
 * Hook to check if the current user has admin access in at least one sector of a given company.
 * This mirrors the logic in backstrapi/src/middlewares/verify-company-admin-access.ts
 */
export const useIsCompanyAdmin = (companyId?: DocID | null) => {
  const { data: accountAccesses = [] } = useAccountAccesses();

  const isCompanyAdmin = useMemo(() => {
    if (!companyId) return false;

    return accountAccesses.some(
      (access) =>
        access.company.documentId === companyId && access.role === "admin"
    );
  }, [accountAccesses, companyId]);

  return isCompanyAdmin;
};
